module.exports = __webpack_public_path__ + "img/icon-gen-ai.302f93b1.svg";